window.addEventListener("load", function () {
    /* Map JS is responsible for initializing the map, not the App JS. But during build, the script here are transferred to App JS to make life more difficult*/
    let googleMapsScriptIsInjected = false;
    const injectGoogleMapsApiScript = () => {
        if (googleMapsScriptIsInjected) {
            throw new Error("Google Maps Api is already loaded.");
        }

        const url =
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyCqAccmQEnAmaH_f-bt0tG2leduPTEQHpg";

        const script = document.createElement("script");

        script.setAttribute("src", url);
        script.setAttribute("async", "");
        script.setAttribute("defer", "");

        document.head.appendChild(script);
        googleMapsScriptIsInjected = true;
    };

    function initMap() {
        const google = window.google;
        if (typeof google !== "object") {
            console.warn("Google not yet ready. Delaying init map");
            setTimeout(initMap, 700);
            return false;
        }
        
        const mapSelector = document.querySelectorAll(".ct-js-googleMap");
        const marker_address = mapSelector[0].getAttribute("data-address");
        let draggable = true;
        if (window.innerWidth <= 767) {
            draggable = false;
        }
        const mapStyle = [
            {
                featureType: "administrative",
                elementType: "labels.text.fill",
                stylers: [{ color: "#444444" }],
            },
            {
                featureType: "landscape",
                elementType: "all",
                stylers: [{ color: "#f2f2f2" }],
            },
            {
                featureType: "poi",
                elementType: "all",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "road",
                elementType: "all",
                stylers: [{ saturation: -100 }, { lightness: 45 }],
            },
            {
                featureType: "road.highway",
                elementType: "all",
                stylers: [{ visibility: "simplified" }],
            },
            {
                featureType: "road.arterial",
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "transit",
                elementType: "all",
                stylers: [{ visibility: "off" }],
            },
            {
                featureType: "water",
                elementType: "all",
                stylers: [{ color: "#425a68" }, { visibility: "on" }],
            },
        ];
        const map = new google.maps.Map(mapSelector[0], {
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP, //MapTypeId.ROADMAP, MapTypeId.SATELLITE, MapTypeId.HYBRID, MapTypeId.TERRAIN
            styles: mapStyle,
            scrollwheel: false,
            draggable: draggable,
            zoom: 15,
        });
        const bounds = new google.maps.LatLngBounds();
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(
            { address: marker_address },
            function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    const marker = new google.maps.Marker({
                        position: new google.maps.LatLng(
                            results[0].geometry.location.lat(),
                            results[0].geometry.location.lng()
                        ),
                        map: map,
                        icon: "wp-content/themes/event-landingpage/assets/img/marker.png",
                    });

                    bounds.extend(marker.position);
                    map.setCenter(results[0].geometry.location);
                    return;
                }
                
                alert(
                    "Geocode was not successful for the following reason: " +
                        status
                );
                
            }
        );
    }
    const googleMapElement = document.getElementsByClassName("ct-googleMap-full");
    if (!googleMapElement.length) {
        return;
    }

    const onViewObserver = new IntersectionObserver(function (
        entries
    ) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                injectGoogleMapsApiScript();
                setTimeout(function () {
                    initMap();
                }, 500);
                //
            }
        });
    });
    onViewObserver.observe(googleMapElement[0]); // fire the init once the map contaier is on view port
});
